export const listingCardBodyTextSx = {
  fontSize: '0.875rem',
  lineHeight: 1.43,
} as const;

export const listingCardSecondaryTextSx = {
  fontSize: '0.75rem',
  lineHeight: 1.33,
  color: 'text.secondary',
} as const;
